import { Link, useNavigate, useParams } from "react-router-dom";
import worksheets from "../data/worksheets.json";
import AdBanner from "../components/AdBanner";

function WorksheetPage(){

const { id } = useParams();
const navigate = useNavigate();

// convert id to number
const worksheet = worksheets.find(w => w.id === Number(id));

if(!worksheet){
return <h2>Worksheet not found</h2>
}

return(

<div style={{padding:"20px"}}>

<div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "18px"}}>
  <button
    onClick={() => navigate(-1)}
    style={{
      padding: "8px 12px",
      borderRadius: "10px",
      border: "1px solid #333",
      background: "#fff",
      cursor: "pointer"
    }}
  >
    ← Back
  </button>
  <Link to="/" style={{textDecoration: "none", fontWeight: "600"}}>Home</Link>
</div>

<h1>{worksheet.title}</h1>

<a href={worksheet.preview} target="_blank" rel="noreferrer">
  <button
    style={{
      padding:"8px 12px",
      fontSize:"14px",
      marginBottom:"12px"
    }}
  >
    Open Preview
  </button>
</a>

<p><b>Grade:</b> {worksheet.grade}</p>

<p><b>Subject:</b> {worksheet.subject}</p>

<br/>

<a href={worksheet.file} target="_blank" rel="noreferrer">

<button
style={{
padding:"10px",
fontSize:"16px"
}}

>

Download Worksheet </button>

</a>

<br/><br/>

<AdBanner/>

</div>

)

}

export default WorksheetPage;
